module.exports = "<v-layout column>\n  HEY\n</v-layout>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/documents/document-detail/template.html
// module id = qUf0
// module chunks = 0